import styled from "styled-components";

// 디바이스 전체화면/수직배치
export const Background = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
`;

// 디바이스 전체화면/수직배치/중앙정렬
export const CenterBackground = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

// 최대화면/수직배치/중앙정렬
export const CenterContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContentContainerBase = styled.div`
  width: 100%;
  height: calc(100vh - 60px);
  margin-top: 60px;
  display: flex;
  flex-direction: column;
`;
